import React from "react";

import "./ExpandedPlaylistHeader.css";

/* eslint-disable react/no-unused-prop-types */
export interface ExpandedPlaylistHeaderConfig {
  playlistName: string;
  playlistDescription: string;
  playlistAuthorUserHandle: string;
}
/* eslint-enable react/no-unused-prop-types */

export const demoProps1ExpandexPlaylistHeaderConfig: ExpandedPlaylistHeaderConfig =
  {
    playlistName: "What a great playlist",
    playlistDescription:
      "What a very beautiful playlist.\nIndeed, it is.\nIndeed, it is.",
    playlistAuthorUserHandle: "Moishe",
  };

// function _ProfilePicture(props: ExpandedPlaylistHeaderConfig): JSX.Element {
//   return (
//     <div>
//       <Image
//         id="ProfileImage"
//         publicId={props.profilePicId}
//         cloudName="dfno6k3qf"
//         secure="true"
//       >
//         <Transformation
//           radius="max"
//           width="100"
//           height="100"
//           gravity="face"
//           dpr="auto"
//           crop="fill"
//         />
//       </Image>
//     </div>
//   );
// }

// function _UserProfileFollowersFollowing(
//   props: UserProfileHeaderConfig
// ): JSX.Element {
//   return (
//     <div id="UserProfileFollowerContainer">
//       <span className="UserFollow">
//         <span className="FollowNumber">{props.followersCount}</span> followers
//       </span>
//       <span className="UserFollow">
//         <span className="FollowNumber">{props.followingCount}</span> following
//       </span>
//     </div>
//   );
// }

// return a JSX.Element where any links in the text are clickable
function _LinkifyText(text: string): JSX.Element {
  const linkifiedText = text.replace(
    /(\s|^)(https?:\/\/[^\s]+)/g,
    "$1<a href='$2'>$2</a>"
  );

  // eslint-disable-next-line @typescript-eslint/naming-convention, react/no-danger
  return <span dangerouslySetInnerHTML={{ __html: linkifiedText }} />;
}

function _ExpandedPlaylistHeader(
  props: ExpandedPlaylistHeaderConfig
): JSX.Element {
  return (
    <div className="ExpandexPlaylistHeaderContainer">
      <div className="ExpandexPlaylist_PlaylistName">{props.playlistName}</div>
      <div className="ExpandexPlaylist_PlaylistDescription">
        {_LinkifyText(props.playlistDescription)}
      </div>
      <div className="ExpandexPlaylist_PlaylistBy">
        {`a playlist by @${props.playlistAuthorUserHandle}`}
      </div>
    </div>
  );
}

export function ExpandedPlaylistHeader(
  props: ExpandedPlaylistHeaderConfig
): JSX.Element {
  return (
    <div>
      <_ExpandedPlaylistHeader {...props} />
    </div>
  );
}
